import React from "react";
import useCachedFetch from "./hooks/useCachedFetch";
import GalleryAlbumCard from "../gallery/GalleryAlbumCard";
import styles from "./styles/Gallery.module.css";
import { useTranslation } from 'react-i18next';

const Gallery = ({ user, isOwnProfile, disabled }) => {
  const { t } = useTranslation('profile');
  // 現在ログイン中ユーザー取得（未ログイン時は null 応答にする）
  const { data: meData, loading: meLoading } = useCachedFetch(
    "current-user",
    async (signal) => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/user`, {
        signal,
        credentials: "include",
      });
      if (!res.ok) return null; // 未ログインなどは null にする
      return res.json();
    },
    { enabled: !disabled && typeof isOwnProfile !== "boolean" } // 明示指定がある場合は取得不要
  );

  const resolvedIsOwn =
    typeof isOwnProfile === "boolean"
      ? isOwnProfile
      : (meData?.id ? meData.id === user?.id : false);

  const endpoint = resolvedIsOwn
    ? `${process.env.REACT_APP_API_URL}/me/gallery/albums`
    : `${process.env.REACT_APP_API_URL}/users/${user?.id}/gallery/albums`;

  const cacheKey = resolvedIsOwn
    ? `gallery-albums:me`
    : `gallery-albums:user:${user?.id}`;

  const { data, loading, error } = useCachedFetch(
    cacheKey,
    async (signal) => {
      const res = await fetch(endpoint, {
        signal,
        credentials: "include",
      });

      if (!res.ok) throw new Error(`albums failed: ${res.status}`);
      return res.json();
    },
    { enabled: !disabled && !!user?.id && (typeof isOwnProfile === "boolean" ? true : !meLoading), ttlMs: 60_000 }
  );

  const albums = data?.data ?? [];

  if (disabled) return <div>{t('galleryUnavailableDraft')}</div>;
  if (loading) return <div>{t('loading')}</div>;
  if (error) return <div>{t('galleryLoadFailed')}</div>;
  if (!albums.length) return <div>{t('noGallery')}</div>;

  return (
    <div className={styles.grid}>
      {albums.map((album) => (
        <GalleryAlbumCard
          key={album.event_id}
          album={album}
        />
      ))}
    </div>
  );
};

export default Gallery;
